/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CatalogPermissionDto } from '../models';
/**
 * RestPermissionsApi - axios parameter creator
 */
export const RestPermissionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the closed permission catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestPermissionsApi - functional programming interface
 */
export const RestPermissionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestPermissionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the closed permission catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CatalogPermissionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestPermissionsApi.getPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestPermissionsApi - factory interface
 */
export const RestPermissionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestPermissionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the closed permission catalog
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissions(options?: RawAxiosRequestConfig): AxiosPromise<Array<CatalogPermissionDto>> {
            return localVarFp.getPermissions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestPermissionsApi - interface
 */
export interface RestPermissionsApiInterface {
    /**
     * 
     * @summary Get the closed permission catalog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPermissions(options?: RawAxiosRequestConfig): AxiosPromise<Array<CatalogPermissionDto>>;

}

/**
 * RestPermissionsApi - object-oriented interface
 */
export class RestPermissionsApi extends BaseAPI implements RestPermissionsApiInterface {
    /**
     * 
     * @summary Get the closed permission catalog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPermissions(options?: RawAxiosRequestConfig) {
        return RestPermissionsApiFp(this.configuration).getPermissions(options).then((request) => request(this.axios, this.basePath));
    }
}

